import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { registerEntry } from '../../Redux/Actions/actions';
import styles from './DniLoginModal.module.css';
import defaultUserImage from '../../Assets/logoUsuarios.png';

const DniLoginModal = () => {
  const dispatch = useDispatch();
  const gym = useSelector(state => state.gym);

  const {
    entryLoading,
    entryMessage,
    entryError,
    entryUserData
  } = useSelector(state => state);

  const [dni, setDni] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const timerRef = useRef(null);
  const inputRef = useRef(null);

  const resetAll = () => {
    setDni('');
    setShowResult(false);
    setMessage('');
    setSuccess(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setTimeout(() => inputRef.current?.focus(), 50);
  };

  const handleInputChange = (e) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    resetAll(); // Siempre resetear al cambiar algo
    const cleanValue = e.target.value.replace(/\D/g, '');
    setDni(cleanValue);
  };

const handleKeyDown = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();

    // Si ya hay resultado mostrado, Enter resetea todo
    if (showResult) {
      resetAll();
      return;
    }

    // Si no hay resultado, procede con búsqueda
    if (dni && !entryLoading) {
      dispatch(registerEntry(dni, gym.id));
    }
  }
};


  useEffect(() => {
    // Usuario encontrado correctamente
    if (entryMessage && !entryError) {
      setShowResult(true);
      setMessage(entryMessage);
      setSuccess(true);
      timerRef.current = setTimeout(() => resetAll(), 10000);
    }

    // Usuario no habilitado u otro error
    if (entryError) {
      setShowResult(true);
      setMessage(entryError);
      setSuccess(false);
      timerRef.current = setTimeout(() => resetAll(), 10000);
    }
  }, [entryMessage, entryError]);

  const calcularDiasRestantes = (fechaVencimiento) => {
    const hoy = new Date();
    const vencimiento = new Date(fechaVencimiento);
    hoy.setHours(0, 0, 0, 0);
    vencimiento.setHours(0, 0, 0, 0);
    const diffMs = vencimiento - hoy;
    return Math.max(Math.ceil(diffMs / (1000 * 60 * 60 * 24)), 0);
  };

  return (
    <div className={styles.modalContainer}>
      <h3>Ingreso por DNI</h3>
      <input
        ref={inputRef}
        type="text"
        placeholder="Ingrese DNI"
        value={dni}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        autoFocus
        inputMode="numeric"
        className={styles.input}
      />

      {showResult && (
        <div className={styles.result}>
          {success ? (
            <div className={styles.success}>
              <div className={styles.userData}>
                <img
                  src={entryUserData?.photo || defaultUserImage}
                  alt="Foto de usuario"
                  className={styles.userImage}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultUserImage;
                  }}
                />
              </div>
              <h4>¡Bienvenido! {entryUserData?.name} {entryUserData?.last_name}</h4>
              <p>{message}</p>
              {entryUserData?.cuota_vencimiento && (
                <p>
                  <strong>Cuota paga hasta:</strong> {entryUserData.cuota_vencimiento} (
                  {calcularDiasRestantes(entryUserData.cuota_vencimiento)} días restantes)
                </p>
              )}
            </div>
          ) : (
            <div className={styles.error}>
              <p>{message}</p>
            </div>
          )}
          <p style={{ marginTop: 16, fontSize: 14, color: '#888' }}>
            Presione <b>Enter</b> para ingresar otro DNI.
          </p>
        </div>
      )}
    </div>
  );
};

export default DniLoginModal;
